"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Radio = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _lodash = require("lodash");
var _utils = require("../../utils");
var _excluded = ["children", "name", "wrapperStyles", "radioStyles", "labelStyles", "type", "disabled"]; // For some reason importing this from '@utils' in Storybook
// causes useUniqueHtmlId to be undefined
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
function RadioGroup(_ref) {
  var children = _ref.children,
    name = _ref.name,
    value = _ref.value,
    disabled = _ref.disabled,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? _lodash.noop : _ref$onChange;
  var childArray = (0, _react.useMemo)(function () {
    return _react.default.Children.toArray(children);
  }, [children]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, childArray.map(function (child) {
    return /*#__PURE__*/_react.default.cloneElement(child, {
      name: name,
      // `value` becomes stringified when passed back as event.target.value as a quirk of HTML.
      // For now, stringify both values first to be able to use the strict equality (===) operator
      checked: String(value) === String(child.props.value),
      disabled: disabled || child.props.disabled,
      onChange: onChange
    });
  }));
}
var RadioRef = /*#__PURE__*/(0, _react.forwardRef)(function (_ref2, ref) {
  var children = _ref2.children,
    name = _ref2.name,
    wrapperStyles = _ref2.wrapperStyles,
    radioStyles = _ref2.radioStyles,
    labelStyles = _ref2.labelStyles,
    type = _ref2.type,
    disabled = _ref2.disabled,
    props = _objectWithoutProperties(_ref2, _excluded);
  var _useInputValidation = (0, _utils.useInputValidation)(props),
    checked = _useInputValidation.checked;
  var value = props.value;
  var id = (0, _utils.useUniqueHtmlId)("radio-".concat(name));
  return (
    /*#__PURE__*/
    // Adding constant height so that it doesn't shift when label font weight changes
    _react.default.createElement("div", {
      className: (0, _classnames.default)('radio-wrapper h-[21px]', wrapperStyles)
    }, /*#__PURE__*/_react.default.createElement("input", _extends({
      name: name,
      id: id,
      type: "radio",
      className: (0, _classnames.default)('radio peer radio-peer', type === 'light' ? 'radio-light' : 'radio-dark', 'appearance-none rounded-full cursor-pointer disabled:cursor-not-allowed', 'before:none before:relative before:rounded-full before:top-[3px] before:left-[3px] before:w-[12px] before:h-[12px]', 'checked:before:block', radioStyles),
      checked: checked,
      disabled: disabled,
      value: value,
      ref: ref
    }, props)), children && /*#__PURE__*/_react.default.createElement("label", {
      htmlFor: id,
      className: (0, _classnames.default)('radio-label', 'ml-[12px] tw-label-regular leading-[16px] pt-px cursor-pointer', 'peer-checked:tw-label-medium peer-disabled:cursor-not-allowed', labelStyles)
    }, children))
  );
});
var Radio = Object.assign(RadioRef, {
  Group: RadioGroup
});
exports.Radio = Radio;